import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import PartnerRequiredFields from '@zr/jobseeker-public/apps/partner-required-fields/components/PartnerRequiredFields';

import { applyDataPropTypes } from '../../../applyFlowPropTypes';
import {
  PARTNER_REQUIRED_FIELDS,
  partnerRequiredFieldsPropTypes,
} from '../../../screenTypeSchema';

import screenTypeTelemetry from '../screenTypeTelemetry';

import './PartnerRequiredFields.less';

export function PartnerRequiredFieldsScreenType({
  applyData,
  onScreenTypeFinish,
  screenTypeParameters,
  setIsLoading,
}) {
  const {
    location_autocomplete_url: locationAutocompleteUrl,
    profile_city: profileCity,
    profile_state: profileState,
    profile_country: profileCountry,
    profile_zipcode: profileZipCode,
  } = screenTypeParameters;

  // transform "1" or undefined into a sane boolean type
  const reattemptRequiredFields = !!parseInt(screenTypeParameters.partner_req_fields_submitted);

  const {
    logView,
    logFinish,
  } = screenTypeTelemetry(PARTNER_REQUIRED_FIELDS, applyData);

  // log initial screen view
  useEffect(() => {
    logView();
  }, [logView]);

  const handleScreenTypeFinish = async () => {
    logFinish();
    await onScreenTypeFinish({
      // extra search params for partner required fields
      // this is for reattempt logic
      partner_req_fields_submitted: 1,
    });
  };

  return (
    <>
      <div className="title">Confirm Location</div>
      <PartnerRequiredFields
        locationAutocompleteUrl={locationAutocompleteUrl}
        onDone={handleScreenTypeFinish}
        profileCity={profileCity}
        profileCountry={profileCountry}
        profileState={profileState}
        profileZipCode={profileZipCode}
        reattemptRequiredFields={reattemptRequiredFields}
        setIsLoading={setIsLoading}
      />
    </>
  );
}

PartnerRequiredFieldsScreenType.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  screenTypeParameters: partnerRequiredFieldsPropTypes.isRequired,
  setIsLoading: PropTypes.func,
};

PartnerRequiredFieldsScreenType.defaultProps = {
  setIsLoading: () => {},
};

export default PartnerRequiredFieldsScreenType;
